<template>
    <div class="view view__licence_show">
        <licence-show/>
    </div>
</template>

<script>
import licenceShow from '@/components/ebs/licences/show/LicenceShow'

export default {
  components: { licenceShow },
  name: 'view-licence-show',
  computed: {
    routeLicenceId () {
      return this.$route.params.offerId
    }
  },
  methods: {
    clearLicence () {
      this.$store.dispatch('ebsLicenceClear')
    },
    getLicence () {
      this.$eventBus.$emit('start-loading')
      this.$store.dispatch('ebsLicenceGet', this.routeLicenceId).finally(() => {
        this.$eventBus.$emit('stop-loading')
      })
    },
    clearLicenceConsumptions () {
      this.$store.dispatch('ebsLicenceConsumptionsClear')
    }
  },
  created () {
    this.clearLicenceConsumptions()
    this.clearLicence()
    this.getLicence()
  }
}
</script>
